module.exports = {"cashier":"budtender","kioskWelcome":"Thank you for registering. Check in each time you make a purchase to earn points and redeem for rewards."}


//////////////////
// WEBPACK FOOTER
// ./src/static/strings.json
// module id = 617
// module chunks = 0